import React, { FC, useEffect, useState } from 'react';
import { IBlockBannerProps } from './BlockBanner.types';
import {
  BannerImage,
  BannerText,
  BlockBannerBackgroundImageWrapper,
  BlockBannerWrapper,
} from './BlockBanner.styles';
import Image from "next/legacy/image";
import { BannerRightImage, DesktopLinkatİl } from '@/icons';
import { getSessionStorage, imageLoader } from '@/utils';
import { useRouter } from 'next/router';


const BlockBanner: FC<IBlockBannerProps> = ({
  mobileBackgroundImage,
  backgroundImage,
  text1,
  text2,
  tarriffPage,
}) => {
  const router = useRouter();
  const [linkat, setLinkat] = useState<boolean>(false)

  useEffect(() => {
    if (router.query.couponCode || router.query.couponCode == '' || getSessionStorage("couponCode") || getSessionStorage("journey_subtype")) {
      setLinkat(true)
    }
  }, [router])

  return (
    <BlockBannerWrapper tarriffPage={tarriffPage}>
      <BlockBannerBackgroundImageWrapper
        id='blockBannerWrapper'
        mobileBackgroundImage={linkat ? "https://cms.vodafone.com.tr/static/img/content/24-10/07/mobile-banner-2.svg" : mobileBackgroundImage}
        backgroundImage={backgroundImage}
        text1="Yenilenen Vodafone Ev İnterneti "
        text2='ile Evleri Yeniliyoruz!'
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <BannerText id='blockBannerWrapperMobil' tarriffPage={tarriffPage}>
            <span id='text1'>{linkat ? "Adımları tamamlayın, size özel hediyeleri," : text1}</span><br />
            <span id='text2'>{linkat ? "kazanma fırsatını kaçırmayın!" : text2}</span>
          </BannerText>

        </div>
        <BannerImage id='bannerImageDiv' mobileBackgroundImage={linkat ? "https://cms.vodafone.com.tr/static/img/content/24-10/07/mobile-banner-2.svg" : mobileBackgroundImage}
          backgroundImage={backgroundImage}>
          <Image
            id='bannerImage'
            loader={imageLoader}
            layout="fixed"
            height={222}
            src={linkat ? DesktopLinkatİl : BannerRightImage}
            alt="Vodafone Ev İnterneti"
          /></BannerImage>
      </BlockBannerBackgroundImageWrapper>
    </BlockBannerWrapper >
  );
};

export default BlockBanner;
